import { SwitchProductModule } from '@wix/package-picker-sdk';
import { useCurrentModule } from '../components';
import { useAiRecommendationEnabled } from './useAiRecommendationEnabled';
import { useAnonymous } from './useAnonymous';
import { useUpgradeRecommendation } from './useUpgradeRecommendation';
const NOT_RECOMMENDED = {
  isRecommended: false,
  isAiRecommended: false,
  isUpgradeRecommended: false
};
export const useEffectiveRecommendation = (productId, catalogIsRecommended) => {
  const module = useCurrentModule();
  const {
    isEnabled,
    isLoading
  } = useAiRecommendationEnabled();
  const upgrade = useUpgradeRecommendation();
  const {
    data: offering
  } = module.SDK.eclipseOfferingApiClient.hooks.useFetchOffering({});
  const isRevealed = module.SDK.aiRecommendationStore.useIsRevealed();
  const aiRecommendedProductId = module.SDK.aiRecommendationStore.useRecommendedProductId();
  const {
    isAnonymous
  } = useAnonymous();
  const aiPickAvailability = SwitchProductModule.SDK.hooks.useProductAvailability({
    productId: aiRecommendedProductId ?? ''
  });
  const isAiPickUnavailable = !isAnonymous && !aiPickAvailability.isLoading && !aiPickAvailability.isProductAvailable;
  const isAiPickPending = !isAnonymous && Boolean(aiRecommendedProductId) && aiPickAvailability.isLoading;
  const {
    isFallback
  } = upgrade;
  if (upgrade.isLoading) {
    return NOT_RECOMMENDED;
  }
  if (upgrade.isApplied && upgrade.data || isFallback) {
    var _upgrade$data, _upgrade$data2;
    if (!isRevealed) {
      return NOT_RECOMMENDED;
    }
    const recommendedProductFamilyId = (_upgrade$data = upgrade.data) == null ? void 0 : _upgrade$data.plan.recommendedProductFamilyId;
    if (recommendedProductFamilyId || isFallback) {
      var _offering$products;
      if (isAiPickPending || isAiPickUnavailable) {
        return NOT_RECOMMENDED;
      }
      const isUpgradeRecommended = recommendedProductFamilyId ? (offering == null || (_offering$products = offering.products) == null || (_offering$products = _offering$products.find(candidate => candidate.productId === productId)) == null ? void 0 : _offering$products.productFamilyId) === recommendedProductFamilyId : catalogIsRecommended;
      return {
        isRecommended: isUpgradeRecommended,
        isAiRecommended: false,
        isUpgradeRecommended
      };
    }
    if ((_upgrade$data2 = upgrade.data) != null && _upgrade$data2.plan.suppressCatalogHighlight) {
      return NOT_RECOMMENDED;
    }
  }
  if (isLoading) {
    return NOT_RECOMMENDED;
  }
  if (!isEnabled) {
    return {
      ...NOT_RECOMMENDED,
      isRecommended: catalogIsRecommended
    };
  }
  if (isAiPickPending) {
    return NOT_RECOMMENDED;
  }

  // Revealed with nothing to show (the tier call never settled, or it chose a
  // plan this visitor cannot buy): the catalog pick beats no badge.
  if (isRevealed && (!aiRecommendedProductId || isAiPickUnavailable)) {
    return {
      ...NOT_RECOMMENDED,
      isRecommended: catalogIsRecommended
    };
  }
  const isAiRecommended = isRevealed && !!aiRecommendedProductId && aiRecommendedProductId === productId;
  return {
    isRecommended: isAiRecommended,
    isAiRecommended,
    isUpgradeRecommended: false
  };
};
//# sourceMappingURL=useEffectiveRecommendation.js.map